// QR matrix generator — uses qrcode-generator (bundled, no CDN required)
// Returns a boolean[][] where true = dark module, false = light module.
import qrcode from 'qrcode-generator';
/**
 * Generates the QR module matrix for the given text using H error correction.
 * Returns null if the text is empty or generation fails.
 */
export function getQRMatrix(text) {
    const content = text.trim();
    if (!content)
        return null;
    try {
        const qr = qrcode(0, 'H');
        qr.addData(content);
        qr.make();
        const n = qr.getModuleCount();
        const m = [];
        for (let r = 0; r < n; r++) {
            const row = [];
            for (let c = 0; c < n; c++) {
                row.push(qr.isDark(r, c));
            }
            m.push(row);
        }
        return m;
    }
    catch {
        return null;
    }
}
